export const ROLE_OPTIONS = [
    { value: 'promostores-manager', label: 'Web Store Manager' },
    { value: 'purchasing-rep',      label: 'Purchasing Rep'      },
    { value: 'order-rep',           label: 'Order Rep'           },
    { value: 'client-rep',          label: 'Client Rep'          },
    { value: 'shipping-rep',        label: 'Shipping Rep'        },
    { value: 'design-rep',          label: 'Design Rep'          },
    { value: 'analytics-rep',       label: 'Analytics Rep'       },
    { value: 'administrator',       label: 'Administrator'       },
  ];